/*
 * @FilePath: /tongliao-nethall-h5-standard/src/api/business.js
 */
import request from '@/utils/service';

/* 业务办理查询 */
export function selectBusHandlingPage(params) {
  return request({
    url: `/busHandling/selectBusHandlingPage`,
    method: 'post',
    data: params
  });
}
/* 业务进度查询 */
export function selectBusHandlingProgess(id) {
  return request({
    url: `/busHandling/selectBusHandlingProgess/${id}`,
    method: 'get'
  });
}
/* 获取绑定表卡 */
export function selectAccount() {
  return request({
    url: `/busHandling/selectAccount`,
    method: 'get'
  });
}
/* 根据业务code查询用户须知 */
export function getCustReadingByCode(params) {
  return request({
    url: `/custReading/getCustReadingByCode`,
    method: 'post',
    data: params
  });
}
/* 认证信息 */
export function selectWaterUserRel() {
  return request({
    url: `/busHandling/selectWaterUserRel`,
    method: 'get'
  });
}
/* 业务新增 */
export function addBusHandling(params) {
  return request({
    url: `/client/remoteBiz/api/form/post`,
    method: 'post',
    data: params
  });
}
/* 开户须知  */
export function getNoticeHtml() {
  return request({
    url: `/client/instruction/getByBizType/PSN_BBZ`,
    method: 'get'
  });
}
/* 用水条款说明  */
export function getYSTKSMHtml() {
  return request({
    url: `/client/instruction/getByBizType/YSTKSM`,
    method: 'get'
  });
}
/* 通过ID查询业务信息 */
export function selectBusHandlingById(id) {
  return request({
    url: `/biz/remoteBiz/api/handle/flow/${id}`,
    method: 'get'
  });
}
/* 业务修改 */
export function updateBusHandling(params) {
  return request({
    url: `/busHandling/updateBusHandling`,
    method: 'post',
    data: params
  });
}
/* 业务取消 */
export function cancelReport(params) {
  return request({
    url: `/client/remoteBiz/api/form/handle`,
    method: 'post',
    data: params
  });
}
/* 业务验证 */
export function verification(params) {
  return request({
    url: `/busHandling/verification`,
    method: 'post',
    data: params
  });
}
/* 业务办理用信息 */
export function selectHandUser(params) {
  return request({
    url: `/biz/remote/revenue/select/waterUser?clientCode=${params}`,
    method: 'get'
  });
}
// /busHandling/isMaster

/* 户主验证 */
export function isMaster(params) {
  return request({
    url: `/busHandling/isMaster/${params}`,
    method: 'get'
  });
}

/* 获取营业厅信息 */
export function selectListPageForNetHall() {
  return request({
    url: `/client/remoteOutlets/api/list`,
    method: 'get'
  });
}

export function getTopQuestion(data) {
  return request({
    url: '/back/knowledge/rank',
    method: 'post',
    data
  });
}

export function getTopLabels() {
  return request({
    url: 'back/knowledge/labelRank',
    method: 'get'
  });
}

export function getQuestions(params) {
  return request({
    url: 'back/knowledge/title',
    method: 'get',
    params
  });
}

export function getAnswers(params) {
  return request({
    url: 'back/knowledge/query',
    method: 'get',
    params
  });
}

export function doResolved(params) {
  return request({
    url: 'back/knowledge/resolved',
    method: 'get',
    params
  });
}

export function doUnResolved(params) {
  return request({
    url: 'back/knowledge/unresolved',
    method: 'get',
    params
  });
}
// 显示租户和用户能展示的营业所
// export const getAbodeTreeByTenantId = (params, config = {}) => http.get(`/client/abode/getAbodeTreeByTenantId`, params, config)

export function getAbodeTreeByTenantId(params) {
  return request({
    url: `/client/abode/getAbodeTreeByTenantId`,
    method: 'get',
    params
  });
}

export function getAbodeTreeByTenantIdAndUsedId(params) {
  return request({
    url: `/client/abode/getAbodeTreeByTenantIdAndUsedId/${params}`,
    method: 'get',
    params
  });
}
